import { Link } from 'react-router-dom';

export default function FanResources() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20concert%20venue%20with%20warm%20golden%20stage%20lighting%20and%20soft%20bokeh%20crowd%20background%2C%20elegant%20and%20atmospheric%2C%20warm%20amber%20and%20rose%20tones%2C%20subtle%20lens%20flare%2C%20magical%20and%20inspiring%20moment%2C%20concert%20photography%20aesthetic&width=1800&height=800&seq=yutamaki-cta-01&orientation=landscape"
        alt="友田真希 粉丝应援"
        title="友田真希 粉丝应援资源"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto text-center">
        <p className="text-white/70 text-xs tracking-[0.2em] uppercase mb-2 font-label">Fan Resources</p>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          粉丝应援资源
        </h2>
        <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-10 leading-relaxed">
          加入友田真希官方粉丝应援会，获取最新活动资讯、专属福利与限量周边。让我们一起为真希应援！
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-4xl mx-auto">
          <Link
            to="/category/events"
            className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg hover:bg-white/20 transition-all duration-300"
          >
            <div className="w-14 h-14 flex items-center justify-center">
              <i className="ri-calendar-event-line text-3xl text-white"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-white whitespace-nowrap">艺能活动</h3>
            <p className="text-white/60 text-xs leading-relaxed">粉丝见面会、签售会与演出日程</p>
          </Link>

          <Link
            to="/category/photo"
            className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg hover:bg-white/20 transition-all duration-300"
          >
            <div className="w-14 h-14 flex items-center justify-center">
              <i className="ri-image-line text-3xl text-white"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-white whitespace-nowrap">写真珍藏</h3>
            <p className="text-white/60 text-xs leading-relaxed">精美写真集与独家视觉内容</p>
          </Link>

          <Link
            to="/category/behind"
            className="flex flex-col items-center gap-3 p-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg hover:bg-white/20 transition-all duration-300"
          >
            <div className="w-14 h-14 flex items-center justify-center">
              <i className="ri-vidicon-line text-3xl text-white"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-white whitespace-nowrap">幕后花絮</h3>
            <p className="text-white/60 text-xs leading-relaxed">拍摄现场与未公开精彩瞬间</p>
          </Link>
        </div>
      </div>
    </section>
  );
}